import React from "react";

import "./About.css";

function About() {
  return (
    <div>
      <h1 className="text-center about__hero mt-5">About Us</h1>
      <div className="container">
        <p className="about__paragraph">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Est quam unde
          voluptatem at iste earum molestiae suscipit atque nisi, harum nulla
          minima quas quasi fugiat placeat. Iure corporis, nobis hic minima,
          culpa, consequatur commodi rem fugiat consequuntur blanditiis aliquid
          aut? Enim iusto eveniet animi blanditiis hic dolorem eum impedit, ex
          modi deserunt veritatis eos, iste at nesciunt omnis esse ipsum minima.
        </p>
        <p className="about__paragraph mt-3">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Est quam unde
          voluptatem at iste earum molestiae suscipit atque nisi, harum nulla
          minima quas quasi fugiat placeat. Iure corporis, nobis hic minima,
        </p>
      </div>
    </div>
  );
}

export default About;
